module.exports = "/lucky-balls/img/weager/Page_left.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Page_left.png
// module id = 1168
// module chunks = 0